import { createFileRoute } from '@tanstack/react-router'
import { AuditorDashboardRoutePage } from '@/components/auditor-center/AuditorCyclePages'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/dashboard',
)({
  component: AuditorDashboardRoutePage,
})
